import { toast } from '@codes/ui-kit/components/ui/use-toast';
import { RoleBody, UserInviteParams, UserView } from '@lemoncloud/codes-backend-api';
import { OwnerView } from '@lemoncloud/codes-goods-api';
import { Params } from '@lemoncloud/lemon-web-core';
import { useQuery } from '@tanstack/react-query';

import { ListResult, PaginationType, useCustomMutation } from '@codes/shared';

import { fetchOwners, fetchTeamMembers, inviteMember, refuseMember, updateMemberRole } from '../apis';
import { ownerQueryKeys } from '../consts';

export * from './useOwner';

export const useTeamMembers = (params: Params) => {
    return useQuery<PaginationType<UserView[]>>({
        queryKey: ownerQueryKeys.list(params ?? {}),
        queryFn: async () => {
            const result = await fetchTeamMembers(params);
            return {
                ...result,
                data: result.list || [],
            } as PaginationType<UserView[]>;
        },
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        staleTime: 0,
    });
};

export const useOwners = (params: Params) => {
    return useQuery<ListResult<OwnerView[]>>({
        queryKey: ownerQueryKeys.list(params ?? {}),
        queryFn: async () => {
            const result = await fetchOwners(params);
            return {
                ...result,
                data: result.list || [],
            } as unknown as ListResult<OwnerView[]>;
        },
        refetchOnWindowFocus: false,
    });
};

export const useUpdateMemberRole = () => {
    return useCustomMutation((roleBody: RoleBody) => updateMemberRole(roleBody), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};

export const useInviteMember = () => {
    return useCustomMutation((userInviteParams: UserInviteParams) => inviteMember(userInviteParams), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};

export const useRefuseMember = () => {
    return useCustomMutation((id: string) => refuseMember(id), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};
